import React from 'react';
import { Helmet } from 'react-helmet-async';
import { URLS } from '@shared/utils/urls';

interface Props
  extends Readonly<{
    handle: Maybe<string>;
    eventDisplayName: Maybe<string>;
    imageUrl: Maybe<string>;
    greeting: Maybe<string>;
    hideFromSearchEngines: boolean;
  }> {}

/**
 * This supplies \<Helmet /> from react-helmet-async
 * Use this component to include necessary font imports
 * as well as update the title and meta information
 */
export const GuestSiteHead: React.FC<Props> = props => {
  const { handle, eventDisplayName, imageUrl, greeting, hideFromSearchEngines } = props;

  return (
    <Helmet title={eventDisplayName || undefined}>
      {/* style applicator is being requested already by Html.tsx */}
      <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:ital@0;1&display=swap" rel="stylesheet" />
      <meta property="og:title" content={eventDisplayName || 'Joy'} />
      <meta property="og:site_name" content="Joy" />
      <meta property="og:url" content={`https://withjoy.com/${handle}`} />
      <meta property="og:image" content={imageUrl || undefined} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={greeting || undefined} />
      <script src={URLS.styleApplicatorLib} />
      {hideFromSearchEngines && <meta name="robots" content="noindex" />}
    </Helmet>
  );
};
